import { useCallback } from 'react';
import { generarOrdenTrabajoPDF } from '../pdfGeneratorOrder';
import { savePdf } from '../api/pdfApi'; // ✅ BACKEND

export const useBudgetPdf = ({
    datosGenerales,
    refacciones,
    servicios,
    calculosOrden,
    incluirIVA,
    incluirISR
}) => {
    const generarPDF = useCallback(async () => {
        try {
            const createdAt = new Date().toISOString();

            // 1) Generar PDF (visual)
            generarOrdenTrabajoPDF(
                datosGenerales,
                refacciones,
                servicios,
                calculosOrden,
                incluirIVA,
                incluirISR
            );

            // 2) Preparar registro para backend
            const folio = (datosGenerales?.factura || 'S/N').toString();
            const cliente = (datosGenerales?.cliente || '').toString();
            const total = typeof calculosOrden?.total === 'number' ? calculosOrden.total : null;

            // Fecha para nombre
            let formattedDate = 'S_N';
            try {
                const fecha = datosGenerales?.fecha ? new Date(datosGenerales.fecha) : null;
                if (fecha && !Number.isNaN(fecha.getTime())) {
                    formattedDate = fecha
                        .toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' })
                        .replace(/\//g, '-');
                }
            } catch {
                formattedDate = 'S_N';
            }

            const record = {
                id: `work-order-${folio}`, // upsert: si repites folio, se actualiza
                name: `OrdenTrabajo_${folio}_${formattedDate}.pdf`,
                createdAt,
                type: 'work-order',
                source: 'BudgetModal',
                blobOrUrl: null,
                client: cliente,
                folio,
                total,
                meta: {
                    rawData: {
                        datosGenerales,
                        refacciones,
                        servicios,
                        calculosOrden,
                        incluirIVA,
                        incluirISR
                    }
                }
            };

            // 3) Guardar en BD
            try {
                await savePdf(record);
            } catch (e) {
                console.error('[useBudgetPdf] savePdf backend error:', e);
                // no bloquees generación si falla el guardado
            }
        } catch (err) {
            console.error('[useBudgetPdf] Error al generar PDF:', err);
            alert(`Error al generar el PDF: ${err?.message || err}`);
        }
    }, [datosGenerales, refacciones, servicios, calculosOrden, incluirIVA, incluirISR]);

    return { generarPDF };
};
